<template>
  <div class="order">
    <div class="flex gap-5 justify-between items-end mb-6 mdmax:flex-col">
      <div class="flex w-full gap-5 mdmax:w-full mdmax:flex-col">
        <div class="w-full max-w-lg mdmax:w-full">
          <label
            class="text-base text-neutral-700 font-medium mb-1 inline-block"
            >Pencarian</label
          >
          <div class="relative">
            <TextField
              type="text"
              :withIcon="true"
              placeholder="No. Pesanan, Nama Pengirim / Penerima"
              v-model="keyword"
              @enter="doSearch()"
            />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
          </div>
        </div>
        <div class="w-full max-w-xs mdmax:w-full">
          <label
            class="text-base text-neutral-700 font-medium mb-1 inline-block"
            >Rentang Tanggal</label
          >
          <div class="date-range relative text-xs">
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2 z-1">
              <Calendar color="neutral-700" />
            </div>
            <date-range-picker
              v-model="dateRange"
              :locale-data="{ format: 'dd/mm/yyyy', separator: ' - ' }"
              @update="setDate"
              :showDropdowns="false"
              :timePicker="false"
              :timePicker24Hour="false"
              :ranges="false"
            ></date-range-picker>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white">
      <div class="flex items-center justify-between tab shadow-border-b mdmax:overflow-x-auto">
        <div class="flex items-center">
          <div
            class="relative px-6 py-3 cursor-pointer text-center font-medium flex-shrink-0"
            v-for="(tab, index) in tabList"
            :key="'tab-' + index"
            :class="[
              tab.value === selectedTab?.value
                ? 'active text-neutral-700'
                : 'text-neutral-500'
            ]"
            @click="selectTab(tab)"
          >
            {{ tab.label }}
          </div>
        </div>
      </div>
      <div class="" v-if="filteredData && filteredData.length > 0">
        <div v-for="order in filteredData" :key="order.order_id">
          <InstantDeliveryCard :data="order" />
        </div>
      </div>
      <div class="py-10 text-center" v-else>Data tidak ditemukan!</div>
    </div>
    <div
      class="text-neutral-500 font-medium mt-2 text-sm"
      v-if="!isMobile && filteredData && filteredData.length > 0"
    >
      Menampilkan {{ start }} - {{ end }} dari {{ totalRecords }}
    </div>
    <div
      class="mt-8 flex justify-end items-center mb-6"
      v-if="filteredData && filteredData.length > 0"
    >
      <pagination
        :currentPage="queries.page"
        :totalCount="totalRecords"
        :pageSize="queries.per_page"
        @onPageChange="onPageChange"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import DateRangePicker from "vue2-daterange-picker"
import "vue2-daterange-picker/dist/vue2-daterange-picker.css"
import dayjs from "dayjs"
const NOW = new Date()
export default {
  components: {
    DateRangePicker,
    TextField: () =>
      import(/* webpackChunkName: "Forms" */ "@/components/Forms/TextField"),
    Search: () =>
      import(/* webpackChunkName: "Forms" */ "@/components/Icons/Search"),
    Calendar: () =>
      import(/* webpackChunkName: "Forms" */ "@/components/Icons/Calendar"),
    InstantDeliveryCard: () =>
      import(/* webpackChunkName: "card" */ "@/components/OrderCard/InstantDeliveryCard"),
    Pagination: () =>
      import(
        /* webpackChunkName: "Pagination" */ "@/components/Pagination/Pagination"
      )
  },
  data: () => ({
    tabList: [
      {
        label: "Semua",
        value: "Semua"
      },
      {
        label: "Menunggu Pembayaran",
        value: "Menunggu Pembayaran"
      },
      {
        label: "Dalam Pengiriman",
        value: "Dalam Pengiriman"
      },
      {
        label: "Selesai",
        value: "Selesai"
      }
    ],
    dateRange: {
      startDate: new Date(NOW.getFullYear(), NOW.getMonth(), 1),
      endDate: NOW
    },
    selectedTab: "",
    keyword: "",
    totalRecords: 0,
    queries: {
      page: 1,
      per_page: 10,
      search_keyword: "",
      start_date: "",
      end_date: "",
      status: "Semua"
    }
  }),
  computed: {
    ...mapGetters("instantDelivery", ["instantDeliveryList"]),
    ...mapGetters("common", ["isMobile"]),
    filteredData() {
      return this.instantDeliveryList || []
    },
    start() {
      return (this.queries.page - 1) * this.queries.per_page + 1
    },
    end() {
      const lastOnPage =
        (this.queries.page - 1) * this.queries.per_page + this.queries.per_page
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    }
  },
  created() {
    this.initPage()
  },
  watch: {
    $route(val) {
      if (Object.keys(val.query).length > 0) {
        this.getList(this.queries)
      } else {
        this.$router.push({ path: "/order/instant-deliveries", query: this.queries })
      }
    }
  },
  methods: {
    ...mapActions("instantDelivery", ["getInstantDeliveries"]),
    ...mapActions("common", ["showLoading", "hideLoading"]),
    initPage() {
      if (Object.keys(this.$route.query).length < 1) {
        this.queries.start_date = dayjs(
          String(this.dateRange.startDate)
        ).format("YYYY-MM-DD")
        this.queries.end_date = dayjs(String(this.dateRange.endDate)).format(
          "YYYY-MM-DD"
        )
        this.$router.push({ path: "/order/instant-deliveries", query: this.queries })
        this.selectedTab = this.tabList.filter(
          (item) => item.value === this.queries.status
        )[0]
      } else {
        const queries = Object.assign({}, this.$route.query)
        this.queries = queries
        this.queries.page = this.queries.search_keyword
          ? 1
          : parseInt(queries.page)
        this.keyword = this.queries.search_keyword || ""
        this.dateRange = {
          startDate: this.queries.start_date,
          endDate: this.queries.end_date
        }
        this.queries.per_page = parseInt(queries.per_page)
        this.selectedTab = this.tabList.filter(
          (item) => item.value === this.queries.status
        )[0]

        if (this.queries.search_keyword && this.queries.page !== 1) {
          this.$router.push({ path: "/order/instant-deliveries", query: this.queries })
        } else {
          this.getList(this.queries)
        }
      }
    },
    setDate(value) {
      this.queries.start_date = dayjs(String(value.startDate)).format(
        "YYYY-MM-DD"
      )
      this.queries.end_date = dayjs(String(value.endDate)).format("YYYY-MM-DD")
      this.$router.push({ query: this.queries })
    },
    selectTab(tab) {
      this.selectedTab = tab
      this.queries.status = tab.value
      this.queries.search_keyword = ""
      this.queries.page = 1
      this.keyword = ""
      this.$router.push({ query: this.queries })
    },
    doSearch() {
      this.queries.search_keyword = this.keyword
      this.queries.page = 1
      this.$router.push({ query: this.queries })
    },
    onPageChange(page) {
      this.queries.page = page
      this.$router.push({ path: "/order/instant-deliveries", query: this.queries })
    },
    getList(queries = "") {
      this.showLoading()
      this.getInstantDeliveries({
        params: queries
      })
        .then((res) => {
          this.totalRecords = res.data.meta.total_item
          this.hideLoading()
        })
        .catch((error) => {
          this.hideLoading()
          console.log("error", error.response)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.order {
  &::v-deep .vs__search {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
  }
  &::v-deep .vdpComponent {
    font-size: 16px;
    display: block;
  }
  &::v-deep .vdpComponent input {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    border-color: rgba(206, 213, 222, 1);
    border-width: 1px;
    border-style: solid;
    width: 100%;
  }
}
.date-range {
  &::v-deep .reportrange-text {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 2.75rem;
    padding-right: 0.75rem;
    border-radius: 0.5rem;
    border-color: rgba(206, 213, 222, 1);
    border-width: 1px;
    border-style: solid;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
  }
  &::v-deep .vue-daterange-picker {
    display: block;
  }
}
.tab {
  .active {
    &::after {
      content: "";
      display: block;
      height: 4px;
      width: 100%;
      background-color: #61d7cf;
      position: absolute;
      left: 0;
      bottom: 0;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
  }
}
</style>
